import { MenuBar } from "./src/MenuBar.js";

export { MenuBar } from "./src/MenuBar.js";

customElements.define('menu-bar',MenuBar);